import { createContext } from 'react';

export const HasTextAncestorContext: React.Context<boolean> = createContext(false);
